import { Upload, PencilLine } from "lucide-react";
import { Emery } from "@/components/ui/Calla";

interface LandingChoiceProps {
  onChooseUpload: () => void;
  onChooseManual: () => void;
}

const EMERY_LANDING =
  "Got a copy of your current policy? Upload it and I'll pre-fill everything I can read. You'll just review what I found and add a few extras.";

export function LandingChoice({ onChooseUpload, onChooseManual }: LandingChoiceProps) {
  return (
    <div className="max-w-lg mx-auto">
      <Emery message={EMERY_LANDING} />

      <div className="step-card">
        <h2
          className="mb-6 text-xl font-semibold"
          style={{ color: "var(--color-navy)" }}
        >
          How would you like to start?
        </h2>

        <button
          type="button"
          onClick={onChooseUpload}
          className="w-full text-left"
          style={{
            border: "2px solid var(--color-primary)",
            background: "var(--bg-primary-subtle, #F0FDF4)",
            padding: "20px",
            borderRadius: 16,
            marginBottom: 16,
            cursor: "pointer",
            transition: "transform 0.1s ease",
          }}
        >
          <div className="flex items-start gap-3">
            <div
              className="flex items-center justify-center"
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "var(--color-primary)",
                color: "white",
                flexShrink: 0,
              }}
            >
              <Upload size={22} strokeWidth={2} />
            </div>
            <div>
              <div
                className="font-semibold mb-1"
                style={{ color: "var(--color-navy)", fontSize: 17 }}
              >
                Upload your declarations page
              </div>
              <div style={{ color: "var(--text-secondary)", fontSize: 14 }}>
                Fastest path, about 2 minutes. PDF, photo, or screenshot.
              </div>
            </div>
          </div>
        </button>

        <button
          type="button"
          onClick={onChooseManual}
          className="w-full text-left"
          style={{
            border: "1px solid var(--border-default, #E5E7EB)",
            background: "white",
            padding: "20px",
            borderRadius: 16,
            cursor: "pointer",
          }}
        >
          <div className="flex items-start gap-3">
            <div
              className="flex items-center justify-center"
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "var(--bg-muted, #F3F4F6)",
                color: "var(--text-secondary)",
                flexShrink: 0,
              }}
            >
              <PencilLine size={22} strokeWidth={2} />
            </div>
            <div>
              <div
                className="font-semibold mb-1"
                style={{ color: "var(--color-navy)", fontSize: 17 }}
              >
                Fill in manually
              </div>
              <div style={{ color: "var(--text-secondary)", fontSize: 14 }}>
                Prefer to type it out? Takes about 5 minutes.
              </div>
            </div>
          </div>
        </button>
      </div>

      <p
        className="mt-4 text-xs text-center"
        style={{ color: "var(--text-muted)" }}
      >
        Your uploaded documents are encrypted and only accessible by OneCalla
        during your audit.
      </p>
    </div>
  );
}
